import React from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const TableRowImpl: React.FC<Props> = (props) => {
  return <div {...props} />;
};

/**
 * A table row container to place all row data as
 * children.  This should only be used within a `<Table/>`
 * element
 *
 * It accepts:
 *  - any react element as children, (will treat as normal
 *    table cell)
 *  - `<TableAction/>` element, which will always rendered as
 *    the last column
 */
export const TableRow = TableRowImpl;

// This is required for `<Table/>` component to recognize TableRow element
TableRow.displayName = 'TableRow';
